import React from "react";
import { Container } from "react-bootstrap";
import DataTable from "react-data-table-component";
import AppLoaderTable from "../AppLoader/AppLoaderTable";

type Props = {
    data?: any,
    columns?: any,
    subHeaderComponent?: any,
    filteredItems?: any,
    deleteMsg?: any,
    deleteMsgtimeout?: any
    showLoader?: boolean,
    actions?: any
}

const TableComponent = ({ data, columns, subHeaderComponent, filteredItems, deleteMsg, deleteMsgtimeout, showLoader, actions }: Props) => {

    return (
        <>
            <Container fluid>

                <div className="text-center text-success">
                    {deleteMsgtimeout && (deleteMsg && <b>{deleteMsg}</b>)}
                    {/* <h6>{textvisible && (action === "edit" ? namess && "Customer " + namess + " details updated successfully" : namess && "Customer " + namess + " created successfully")}</h6> */}
                </div>
                <DataTable
                    progressPending={showLoader}
                    progressComponent={<AppLoaderTable />}
                    columns={columns}
                    data={filteredItems}
                    pagination
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    highlightOnHover
                    subHeader
                    persistTableHead
                    subHeaderComponent={subHeaderComponent}
                    actions={actions}
                />
            </Container>
        </>
    )
}

export default TableComponent;